module.exports = __webpack_public_path__ + "img/smiley.c5e9c18b.png";